import { Checkbox, Dialog, DialogTitle, FormControlLabel, IconButton } from "@material-ui/core";
import { Tooltip } from "@material-ui/core";
import { Delete, Edit } from "@material-ui/icons";
import React, { useState, useEffect } from "react";
import ReactTable from "react-table";

import Button from "components/CustomButtons/Button.jsx";
import { INVOICE_STATUS } from "./InvoiceObj";
import InvoicePdfModal from "./InvoicePdfModal";
import { clone, get, orderBy, sortBy } from "lodash";
import moment from 'moment';
import Notification from "../../components/Notification/Notification";
import { FadeLoader } from "react-spinners";
import InvoicePaymentHistory from './InvoicePaymentHistory';
import { calculateTotalInvoicePicture, getInvoiceFormData, getInvoiceFullData } from "./InvoiceLogic";
import axios from 'store/axios/axios-invoice';
import { cloneJ, handleError } from "../../shared/utility";
import { generateInvoiceHTML2 } from "./InvoiceHTML";
import { getIlliNumber } from "../RSheets/RSheetsLogic";
import { getUser } from "../../shared/authValidation";
import { renderReportHTML } from "../PaymentReports/paymentReportsLogic";
import CustomPDFViewer from "../../components/CustomPDFViewer/CustomPDFViewer";
import axios_pr from "store/axios/axios-pr";
import CustomInputValid from "../../components/CustomInput/CustomInputValid";
import GridContainer from "../../components/Grid/GridContainer";
import GridItem from "../../components/Grid/GridItem";
export const INVOICE_VIEW_FILTERS_MODULE = "invoices";
export const INVOICE_COLUMNS_META = [
    { accessor: 'id', Header: 'Invoice ID#' },
    { accessor: 'rs_id', Header: 'RS ID' },
    { accessor: 'invoice_num', Header: 'Invoice #' },
    { accessor: 'illi_number', Header: 'illi #' },
    { accessor: 'bill_to', Header: 'Bill To' },
    { accessor: 'project_name', Header: 'Project Name' },
    { accessor: 'submitter', Header: 'Submitter' },
    { accessor: 'lessee_seller', Header: 'Lessee/Seller' },
    { accessor: 'lessor_buyer', Header: 'Lessor/Buyer' },
    { accessor: 'format_date_created', Header: 'Date Created' },
    { accessor: 'actions', Header: 'Actions' },
];

const getLesseeSellerDisplay = (item) => {
    const lessees = get(item, "json_data.lessees", []) || [];
    if (!Array.isArray(lessees)) return "";
    return lessees.map((l) => {
        const company = get(l, "company_name", "");
        if (company) return company;
        const fn = get(l, "name", "");
        const ln = get(l, "last_name", "");
        return `${fn} ${ln}`.trim();
    }).filter(Boolean).join(", ");
};

const getLessorBuyerDisplay = (item) => {
    const lessors = get(item, "json_data.lessors", []) || [];
    if (!Array.isArray(lessors)) return "";
    return lessors.map((l) => {
        const company = get(l, "company_name", "");
        if (company) return company;
        const fn = get(l, "name", "");
        const ln = get(l, "last_name", "");
        return `${fn} ${ln}`.trim();
    }).filter(Boolean).join(", ");
};

const getBill = (l) => {
    return l.json_data ? 
                        l.json_data.billing_attention || l.json_data.billing_attention_lastname ?
                            `${l.json_data.billing_attention} ${l.json_data.billing_attention_lastname}`
                        : 
                            ''
                    :
                        '';
}

const invoiceActionsStyle = {
    display: 'flex',
    flexWrap: 'nowrap',
    alignItems: 'center',
    gap: 2
};

const invoiceActionButtonStyle = {
    padding: 6,
    width: 34,
    height: 34
};

const InvoiceList = (props) => {
    const {
        data,
        tab,
        openForm,
        parentData,
        setParentData,
        deleteInvoiceEntry,
        getInvoiceEntries,
        getInvoicePdf,
        pdfData,
        updateInvoiceEntry,
        clearInvoicePdfData,
        resendInvoiceEmail,
        success,
        permissions,
        getInvoicePayments,
        invoicePayments
    } = props;

    console.log('InvoiceList', data);

    const [listItems, setListItems] = useState([]);
    const [columns, setColumns] = useState([]);
    const [idToDelete, setIdToDelete] = useState(null);
    const [showInvoiceId, setShowInvoiceId] = useState(false);

    const hiddenColumns = Array.isArray(props.hiddenColumns) ? props.hiddenColumns : [];
    const filteredColumns = columns.filter(c => {
        if (c.accessor === 'id' && !showInvoiceId) return false;
        return hiddenColumns.indexOf(c.accessor) === -1;
    });

    const [openedPdfView, setOpenedPdfView] = useState(false);
    const [localPdfData, setLocalPdfData] = useState(null);
    const [invoiceToReview, setInvoiceToReview] = useState(null);
    const [openedEstimateModal, setOpenedEstimateModal] = useState(null);
    const [estimateRsData, setEstimateRsData] = useState(null);
    const [estimatePdf, setEstimatePdf] = useState(null);

    const currentUserForEstimate = getUser();
    const isSuperAdminForEstimate = currentUserForEstimate && currentUserForEstimate.name === 'CRS Dev';
    const previewEstimatePermitted = isSuperAdminForEstimate || (currentUserForEstimate && currentUserForEstimate.permObj
        ? !!(currentUserForEstimate.permObj['Invoice preview_payment_report_estimate'] ||
             currentUserForEstimate.permObj['PR preview_payment_report_estimate'])
        : false);

    const openEstimateModal = async (item) => {
        setOpenedEstimateModal(item);
        setEstimateRsData(null);
        try {
            const all_data = await calculateTotalInvoicePicture(item.rs_id);
            setEstimateRsData(all_data);
        } catch (e) {
            handleError(e);
        }
    };

    const injectPreviewWatermark = (html) => {
        const watermarkStyle = `<style>
            .preview-watermark {
                position: fixed;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                pointer-events: none;
                z-index: 99999;
            }
            .preview-watermark span {
                font-size: 140px;
                color: rgba(218, 34, 41, 0.18);
                font-weight: 900;
                transform: rotate(-30deg);
                letter-spacing: 12px;
                white-space: nowrap;
                font-family: Arial, sans-serif;
            }
            .preview-banner {
                position: fixed;
                top: 8px;
                right: 8px;
                background: #da2229;
                color: #fff;
                font-weight: bold;
                padding: 4px 10px;
                border-radius: 4px;
                font-size: 11px;
                letter-spacing: 1px;
                z-index: 99999;
                font-family: Arial, sans-serif;
            }
        </style>`;
        const watermarkBody = `<div class="preview-watermark"><span>PREVIEW</span></div><div class="preview-banner">PREVIEW — NOT A FINAL REPORT</div>`;
        let out = html;
        if (out.indexOf('</head>') !== -1) {
            out = out.replace('</head>', watermarkStyle + '</head>');
        } else {
            out = watermarkStyle + out;
        }
        if (out.indexOf('<body>') !== -1) {
            out = out.replace('<body>', '<body>' + watermarkBody);
        } else {
            out = watermarkBody + out;
        }
        return out;
    };

    const previewEstimatePayment = async (invoice, payment, paymentIndex) => {
        if (!estimateRsData) return;
        let payment_for_preview = payment;
        if (!payment_for_preview) {
            const totalDue = parseFloat(invoice.balance_due || invoice.total_amount || 0) || 0;
            payment_for_preview = {
                id: `estimate-${invoice.id}-${paymentIndex || 0}`,
                invoice_id: invoice.id,
                payment_amount: totalDue,
                check_number: 'ESTIMATE',
                date_received: new Date().toISOString().split('T')[0],
                payments: [],
                _is_estimate: true
            };
            const cloneRsData = clone(estimateRsData);
            const targetInvoice = (cloneRsData.invoices || []).find(inv => inv.id === invoice.id);
            if (targetInvoice) {
                if (!Array.isArray(targetInvoice.payments)) targetInvoice.payments = [];
                if (!targetInvoice.payments.find(pp => pp.id === payment_for_preview.id)) {
                    targetInvoice.payments.push(payment_for_preview);
                }
            }
            try {
                const chosen = { invoice_ids: [invoice.id], payment_ids: [payment_for_preview.id] };
                const obj = renderReportHTML(cloneRsData, chosen);
                const stamped = injectPreviewWatermark(obj.finalHTML);
                const resp = await axios_pr.post('/pdf', { htmlContent: stamped });
                if (resp && resp.data) setEstimatePdf(resp.data);
            } catch (e) {
                handleError(e);
                alert('Could not generate estimate preview.');
            }
            return;
        }
        try {
            const chosen = { invoice_ids: [invoice.id], payment_ids: [payment_for_preview.id] };
            const obj = renderReportHTML(estimateRsData, chosen);
            const stamped = injectPreviewWatermark(obj.finalHTML);
            const resp = await axios_pr.post('/pdf', { htmlContent: stamped });
            if (resp && resp.data) setEstimatePdf(resp.data);
        } catch (e) {
            handleError(e);
            alert('Could not generate estimate preview.');
        }
    };

    const [openedSuccessModal, setOpenedSuccessModal] = useState(false);

    const [openPaymentHistory, setOpenPaymentHistory] = useState(false);

    const [waitForInvoicePayments, setWaitForInvoicePayments] = useState(false);

    const [filtersObj, setFiltersObj] = useState({
        lessee: '',
        balance: ''
    });

    const [loadedInvoicePayments, setLoadedInvoicePayments] = useState([]); // new way to load invoice payments

    const [isDeleting, setIsDeleting] = useState(false);

    const [openedPRModal, setOpenedPRModal] = useState(null);

    const handleOpenPaymentHistory = () => setOpenPaymentHistory(true);
    const handleClosePaymentHistory = () => setOpenPaymentHistory(false);

    const openPdfView = () => setOpenedPdfView(true);
    const closePdfView = () => setOpenedPdfView(false);

    const loadInvoicePayments = async (rs_id) => {
        try {
            const response = await axios.get('/payments?rs_id='+rs_id);
            console.log('loaded invoice payments', response.data);
            setLoadedInvoicePayments(response.data);
            return response.data;
        } catch(e) {
            handleError(e);
            console.log('could not get invoices');
        }
        return [];
    }

    const handleResend = async (item) => {
        console.log('resend', item);
        const itemClone = clone(item);
        const invoice_id = item.id;
        const rsData = clone(get(item, 'json_data', {}));
        const billing_email = rsData.billing_email;
        const rsInvoiceData = clone(getInvoiceFormData(rsData, invoice_id));
        itemClone.data.rsData = rsData;
        if (billing_email) {
            // TODO: 
            // resendInvoiceEmail({
            //     html: generateInvoiceHTML({
            //             invoice: get(item, 'data.invoice', ''),
            //             date: get(item, 'data.date', ''),
            //             rsData,
            //             entries: get(rsInvoiceData, 'data.entries', []),
            //             line_items: get(rsInvoiceData, 'data.line_items', [])
            //     }),
            //     data: itemClone.data,
            // })
        }
    }

    useEffect(() => {
        if (waitForInvoicePayments && props.invoicePayments) {
            handleOpenPdfView(parentData);
            setWaitForInvoicePayments(false);
        }
    }, [props.invoicePayments]);

    useEffect(() => {
        if (invoiceToReview) {
            const found = data.find(item => item.id === invoiceToReview.id);

            if (found) {
                setInvoiceToReview(found);
            }
        }
    }, [data])

    useEffect(() => {
        if (success && success === 'Sent Invoice to email successfully') {
            setOpenedSuccessModal(true)
        }
        if (isDeleting && success === 'Successfully deleted') {
            closeDeleteModal();
            getInvoiceEntries(tab);
            setIsDeleting(false);
        }
    }, [success])

    const handlePaymentReport = (item) => {
        console.log('item', item);
        if (item && item.rs_id) {
            getInvoicePayments({
                rs_id: item.rs_id
            });
        }
        setOpenedPRModal(item);
    }

    const handleOpenPdfView2 = (invo_data, invoice_id) => {
        console.log('handling pdfview2')
        const html = generateInvoiceHTML2(invo_data, invoice_id);
        getInvoicePdf({ htmlTemplate: html});
        openPdfView(true);
    }

    const handleOpenPdfView = async (data, theInvoicePayments) => {
        console.log('handleOpenPdfView', data);
        // get all invoices of the rs_id 
        let all_invoices = [];
        try {
            const response = await axios.get(`/entries?rs_id=${data.rs_id}`);
            all_invoices = response.data;
        } catch(e) {
            handleError(e);
        }
        const rsInvoiceData = getInvoiceFullData(data);
        console.log('opening pdf view data ->', data, rsInvoiceData, theInvoicePayments);
        setInvoiceToReview(data);
        openPdfView(true);
    };

    const [openedDeleteModal, setOpenedDeleteModal] = useState(false);
    const [openedPaymentReports, setOpenedPaymentReports] = useState(false);

    const openDeleteModal = (id) => {
        setOpenedDeleteModal(true);
        setIdToDelete(id);
    };
    const closeDeleteModal = () => setOpenedDeleteModal(false);

    const handleClose = () => {
        setIdToDelete(null);
        closeDeleteModal();
    };

    const handleApprove = () => {
        console.log('approving', invoiceToReview);
        return;
    };

    const handleDecline = () => {
        const declinedInvoice = clone(invoiceToReview);
        declinedInvoice.status = INVOICE_STATUS.DECLINE;
        updateInvoiceEntry(declinedInvoice);
    };

    useEffect(() => {
        if (pdfData && typeof pdfData === "string") {
            const parsedPdf = JSON.parse(pdfData);
            setLocalPdfData(parsedPdf);
            clearInvoicePdfData();
        }
    }, [pdfData]);

    const load = (theTab, filtersObj) => {
        if (theTab === INVOICE_STATUS.ALL) {
            getInvoiceEntries([INVOICE_STATUS.DRAFT, INVOICE_STATUS.PENDING, INVOICE_STATUS.DECLINE, INVOICE_STATUS.APPROVED, INVOICE_STATUS.VOIDED], filtersObj);
        } else {
            getInvoiceEntries(theTab, filtersObj);
        }
    }

    useEffect(() => {
        load(tab, filtersObj);
    }, [tab]);

    useEffect(() => {
        if (props.openPDFitemID) {
            let itemToOpen = null;
            if (data) {
                for (let i = 0; i < data.length; i++) {
                    const dat = data[i];
                    if (dat.id === parseInt(props.openPDFitemID)) {
                        itemToOpen = dat;
                        break;
                    }
                }
            }
            if (itemToOpen) {
                handleOpenPdfView(itemToOpen);
                props.resetInvoiceID();
                props.resetOpenPDFitemID();
            }
        }
    }, [props.openPDFitemID, data]);

    useEffect(() => {
        let list = [];

        setColumns([
            {
                Header: "Invoice ID#",
                accessor: "id",
                maxWidth: 50
            },
            {
                Header: "RS ID",
                accessor: "rs_id",
                maxWidth: 50
            },
            {
                Header: "Invoice #",
                accessor: "invoice_num",
                maxWidth: 50
            },
            {
                Header: "illi #",
                accessor: "illi_number",
                maxWidth: 100,
                filterMethod: (filter, row) => {
                    return String(row[filter.id]).toLowerCase().includes(filter.value.toLowerCase());
                }
            },
            {
                Header: "Bill To",
                accessor: "bill_to",
                filterMethod: (filter, row, column) => {
                    const id = filter.pivotId || filter.id;
                    return row[id] ? String(row[id].toLowerCase()).indexOf(filter.value.toLowerCase()) !== -1 : true;
                }
            },
            {
                Header: "Project Name",
                accessor: "project_name",
                filterMethod: (filter, row) => {
                    const value = row[filter.pivotId || filter.id];
                    return value !== undefined
                    ? String(value).toLowerCase().includes(filter.value.toLowerCase())
                    : true;
                }
            },
            {
                Header: "Submitter",
                accessor: "submitter",
            },
            {
                Header: "Lessee/Seller",
                accessor: "lessee_seller",
                filterMethod: (filter, row) => {
                    return String(row[filter.id] || '').toLowerCase().includes(filter.value.toLowerCase());
                }
            },
            {
                Header: "Lessor/Buyer",
                accessor: "lessor_buyer",
                filterMethod: (filter, row) => {
                    return String(row[filter.id] || '').toLowerCase().includes(filter.value.toLowerCase());
                }
            },
            {
                Header: "Date Created",
                accessor: "format_date_created",
                maxWidth: 200
            },
            {
                Header: "Actions",
                accessor: "actions",
                minWidth: 210,
                sortable: false,
                filterable: false
            },
        ]);

        const sortedData = orderBy(cloneJ(data).map(dm => {
            if (dm.json_data) {
                const illi_number = get(dm, 'json_data.illi_number', '');
                dm.title = `Generated from RS illi# - ${illi_number}`;
            }
            dm.lessee_seller = getLesseeSellerDisplay(dm);
            dm.lessor_buyer = getLessorBuyerDisplay(dm);
            return dm;
        }), ['date_created'], 'desc');

        const subFilterMatches = (item) => {
            const sf = props.subFilter || 'all';
            if (sf === 'all') return true;
            if (sf === 'draft') return item.status === INVOICE_STATUS.DRAFT;
            if (sf === 'pending') return item.status === INVOICE_STATUS.PENDING;
            if (sf === 'approved') return item.status === INVOICE_STATUS.APPROVED;
            if (sf === 'declined') return item.status === INVOICE_STATUS.DECLINE;
            if (sf === 'voided') return item.status === INVOICE_STATUS.VOIDED;
            return true;
        };

        if (tab === INVOICE_STATUS.ALL) {
            list = sortedData.filter(subFilterMatches).map((item) => {
                const format_date_created = moment(item.date_created).format('MM/DD/YYYY');
                const bill_to = getBill(item);
                const s = item.status;
                const isVoided = s === INVOICE_STATUS.VOIDED;
                const isApproved = s === INVOICE_STATUS.APPROVED;
                const isDeclined = s === INVOICE_STATUS.DECLINE;
                const isDraft = s === INVOICE_STATUS.DRAFT;
                const isPending = s === INVOICE_STATUS.PENDING;
                const switchToRowTab = () => { if (props.setTab) props.setTab(s); };
                return {
                    ...item,
                    format_date_created,
                    illi_number: get(item, 'json_data.illi_number', ''),
                    project_name: get(item, 'json_data.project_name', ''),
                    bill_to,
                    actions: (
                        <div style={invoiceActionsStyle}>
                            {item.rs_id && <IconButton
                                style={invoiceActionButtonStyle}
                                onClick={() => { window.location.href = '/rs?p=open&rs_id=' + item.rs_id; }}
                            >
                                <Tooltip title="Open RS">
                                    <i className="fa fa-file-alt font-22" />
                                </Tooltip>
                            </IconButton>}
                            {/*
                            {previewEstimatePermitted && <IconButton onClick={() => { switchToRowTab(); openEstimateModal(item); }}>
                                <Tooltip title="Preview Invoice"><span style={{ fontWeight: 'bold', fontSize: 13 }}>EST</span></Tooltip>
                            </IconButton>}
                            */}
                            {isApproved && props.pr_permitted && <IconButton style={invoiceActionButtonStyle} onClick={() => { switchToRowTab(); handlePaymentReport(item); }}>PR</IconButton>}
                            {isApproved && <IconButton style={invoiceActionButtonStyle} onClick={() => { switchToRowTab(); handleResend(item); }}>
                                <Tooltip title="Re-send" placement="bottom"><i className="fa fa-paper-plane"></i></Tooltip>
                            </IconButton>}
                            {(isApproved || isDeclined || isVoided) && <IconButton
                                style={invoiceActionButtonStyle}
                                onClick={async () => {
                                    switchToRowTab();
                                    if (isApproved) {
                                        const invo_data = await calculateTotalInvoicePicture(item.rs_id);
                                        handleOpenPdfView2(invo_data, item.id);
                                        const theInvoicePayments = await loadInvoicePayments(item.rs_id);
                                        setParentData(item);
                                        handleOpenPdfView(item, theInvoicePayments);
                                    } else {
                                        handleOpenPdfView(item);
                                    }
                                }}
                            >
                                <Tooltip title="View" placement="bottom"><i className="fa fa-eye font-22 " /></Tooltip>
                            </IconButton>}
                            {!isVoided && <IconButton
                                style={invoiceActionButtonStyle}
                                onClick={() => {
                                    switchToRowTab();
                                    setParentData(item);
                                    if (isPending || isApproved) {
                                        getInvoicePayments({ rs_id: item.rs_id });
                                    }
                                    openForm();
                                }}
                            >
                                <Tooltip title={isApproved || isDeclined ? "Edit" : "Edit"}>
                                    {isDraft || isPending ? <Edit /> : <i className="fas fa-edit font-22" />}
                                </Tooltip>
                            </IconButton>}
                            {(isDraft || isPending) && <IconButton style={invoiceActionButtonStyle} onClick={() => { switchToRowTab(); openDeleteModal(item.id); }}>
                                <Tooltip title="Delete"><Delete /></Tooltip>
                            </IconButton>}
                            {isApproved && permissions.indexOf('edit_delete_payment_history') !== -1 && <IconButton
                                style={invoiceActionButtonStyle}
                                onClick={() => {
                                    switchToRowTab();
                                    setInvoiceToReview(item);
                                    getInvoicePayments({ rs_id: item.rs_id });
                                    handleOpenPaymentHistory();
                                }}
                            >
                                <Tooltip title="Open Payments">
                                    <i className="fa fa-money-bill-alt font-22 " />
                                </Tooltip>
                            </IconButton>}
                        </div>
                    ),
                };
            });
        } else if (tab === INVOICE_STATUS.DRAFT) {
            list = sortedData.map((item) => {
                const format_date_created = moment(item.date_created).format('MM/DD/YYYY');
                const bill_to = getBill(item);
                return {
                    ...item,
                    format_date_created,
                    bill_to,
                    illi_number: get(item, 'json_data.illi_number', ''),
                    project_name: get(item, 'json_data.project_name', ''),
                    actions: (
                        <div style={invoiceActionsStyle}>
                            {item.rs_id && <IconButton
                                style={invoiceActionButtonStyle}
                                onClick={() => {
                                    window.location.href = '/rs?p=open&rs_id=' + item.rs_id;
                                }}
                            >
                                <Tooltip title="Open RS">
                                    <i className="fa fa-file-alt font-22" />
                                </Tooltip>
                            </IconButton>}
                            {/*
                            {previewEstimatePermitted && <IconButton onClick={() => { openEstimateModal(item); }}>
                                <Tooltip title="Preview Invoice"><span style={{ fontWeight: 'bold', fontSize: 13 }}>EST</span></Tooltip>
                            </IconButton>}
                            */}
                            <IconButton
                                style={invoiceActionButtonStyle}
                                onClick={() => {
                                    setParentData(item);
                                    openForm();
                                }}
                            >
                                <Tooltip title="Edit">
                                    <Edit />
                                </Tooltip>
                            </IconButton>
                            <IconButton
                                style={invoiceActionButtonStyle}
                                onClick={() => {
                                    openDeleteModal(item.id);
                                }}
                            >
                                <Tooltip title="Delete">
                                    <Delete />
                                </Tooltip>
                            </IconButton>
                        </div>
                    ),
                };
            });
        } else if (tab === INVOICE_STATUS.PENDING) {
            list = sortedData.map((item) => {
                const format_date_created = moment(item.date_created).format('MM/DD/YYYY');
                const bill_to = getBill(item);
                return {
                    ...item,
                    format_date_created,
                    illi_number: get(item, 'json_data.illi_number', ''),
                    project_name: get(item, 'json_data.project_name', ''),
                    bill_to,
                    actions: (
                        <div style={invoiceActionsStyle}>
                            {item.rs_id && <IconButton
                                style={invoiceActionButtonStyle}
                                onClick={() => {
                                    window.location.href = '/rs?p=open&rs_id=' + item.rs_id;
                                }}
                            >
                                <Tooltip title="Open RS">
                                    <i className="fa fa-file-alt font-22" />
                                </Tooltip>
                            </IconButton>}
                            {/*
                            {previewEstimatePermitted && <IconButton onClick={() => { openEstimateModal(item); }}>
                                <Tooltip title="Preview Invoice"><span style={{ fontWeight: 'bold', fontSize: 13 }}>EST</span></Tooltip>
                            </IconButton>}
                            */}
                            <IconButton
                                style={invoiceActionButtonStyle}
                                onClick={() => {
                                    setParentData(item);
                                    getInvoicePayments({
                                        rs_id: item.rs_id
                                    });
                                    openForm();
                                }}
                            >
                                <Tooltip title="Edit">
                                    <i className="fas fa-edit font-22" />
                                </Tooltip>
                            </IconButton>
                            <IconButton
                                style={invoiceActionButtonStyle}
                                onClick={() => {
                                    openDeleteModal(item.id);
                                }}
                            >
                                <Delete />
                            </IconButton>
                        </div>
                    ),
                };
            });
        } else if (tab === INVOICE_STATUS.APPROVED) {
            list = sortedData.map((item) => {
                const format_date_created = moment(item.date_created).format('MM/DD/YYYY');
                const bill_to = getBill(item);
                return {
                    ...item,
                    format_date_created,
                    illi_number: get(item, 'json_data.illi_number', ''),
                    project_name: get(item, 'json_data.project_name', ''),
                    bill_to,
                    actions: (
                        <div style={invoiceActionsStyle}>
                            {item.rs_id && <IconButton
                                style={invoiceActionButtonStyle}
                                onClick={() => {
                                    window.location.href = '/rs?p=open&rs_id=' + item.rs_id;
                                }}
                            >
                                <Tooltip title="Open RS">
                                    <i className="fa fa-file-alt font-22" />
                                </Tooltip>
                            </IconButton>}
                            {/*
                            {previewEstimatePermitted && <IconButton onClick={() => { openEstimateModal(item); }}>
                                <Tooltip title="Preview Invoice"><span style={{ fontWeight: 'bold', fontSize: 13 }}>EST</span></Tooltip>
                            </IconButton>}
                            */}
                            {props.pr_permitted && <IconButton
                                style={invoiceActionButtonStyle}
                                onClick={() => {
                                    handlePaymentReport(item);
                                }}
                            >
                                PR
                            </IconButton>}
                            <IconButton
                                style={invoiceActionButtonStyle}
                                onClick={() => {
                                    handleResend(item);
                                }}
                            >
                                <Tooltip title="Re-send" placement="bottom">
                                    <i className="fa fa-paper-plane"></i>
                                </Tooltip>
                            </IconButton>
                            <IconButton
                                style={invoiceActionButtonStyle}
                                onClick={async () => {
                                    console.log('loading itm', item)
                                    const invo_data = await calculateTotalInvoicePicture(item.rs_id);
                                    console.log('loading itm invo_data', invo_data);
                                    handleOpenPdfView2(invo_data, item.id);

                                    const theInvoicePayments = await loadInvoicePayments(item.rs_id);
                                    setParentData(item);
                                    handleOpenPdfView(item, theInvoicePayments);
                                }}
                            >
                                <Tooltip title="View" placement="bottom">
                                    <i className="fa fa-eye font-22 " />
                                </Tooltip>
                            </IconButton>
                            <IconButton
                                style={invoiceActionButtonStyle}
                                onClick={async () => {
                                    setParentData(item);
                                    getInvoicePayments({
                                        rs_id: item.rs_id
                                    });
                                    openForm();
                                }}
                            >
                                <Tooltip title="Edit">
                                    <i className="fas fa-edit font-22" />
                                </Tooltip>
                            </IconButton>
                            {permissions.indexOf('edit_delete_payment_history') !== -1 && <IconButton
                                style={invoiceActionButtonStyle}
                                onClick={() => {
                                    setInvoiceToReview(item);
                                    getInvoicePayments({
                                        rs_id: item.rs_id
                                    });
                                    handleOpenPaymentHistory();
                                }}
                            >   
                                <Tooltip title="Open Payments">
                                    <i className="fa fa-money-bill-alt font-22 " />
                                </Tooltip>
                            </IconButton>}
                        </div>
                    ),
                };
            });
        } else if (tab === INVOICE_STATUS.DECLINE) {
            list = sortedData.map((item) => {
                const format_date_created = moment(item.date_created).format('MM/DD/YYYY');
                const bill_to = getBill(item);
                return {
                    ...item,
                    format_date_created,
                    illi_number: get(item, 'json_data.illi_number', ''),
                    project_name: get(item, 'json_data.project_name', ''),
                    bill_to,
                    actions: (
                        <div style={invoiceActionsStyle}>
                            {item.rs_id && <IconButton
                                style={invoiceActionButtonStyle}
                                onClick={() => {
                                    window.location.href = '/rs?p=open&rs_id=' + item.rs_id;
                                }}
                            >
                                <Tooltip title="Open RS">
                                    <i className="fa fa-file-alt font-22" />
                                </Tooltip>
                            </IconButton>}
                            {/*
                            {previewEstimatePermitted && <IconButton onClick={() => { openEstimateModal(item); }}>
                                <Tooltip title="Preview Invoice"><span style={{ fontWeight: 'bold', fontSize: 13 }}>EST</span></Tooltip>
                            </IconButton>}
                            */}
                            <IconButton
                                style={invoiceActionButtonStyle}
                                onClick={() => {
                                    handleOpenPdfView(item);
                                }}
                            >
                                <i class="fa fa-eye font-22 " />
                            </IconButton>
                            <IconButton
                                style={invoiceActionButtonStyle}
                                onClick={() => {
                                    setParentData(item);
                                    openForm();
                                }}
                            >
                                <Edit />
                            </IconButton>
                        </div>
                    ),
                };
            });
        } else if (tab === INVOICE_STATUS.VOIDED) {
            list = sortedData.map((item) => {
                const format_date_created = moment(item.date_created).format('MM/DD/YYYY');
                const bill_to = getBill(item);
                return {
                    ...item,
                    format_date_created,
                    illi_number: get(item, 'json_data.illi_number', ''),
                    project_name: get(item, 'json_data.project_name', ''),
                    bill_to,
                    actions: (
                        <div style={invoiceActionsStyle}>
                            {item.rs_id && <IconButton
                                style={invoiceActionButtonStyle}
                                onClick={() => {
                                    window.location.href = '/rs?p=open&rs_id=' + item.rs_id;
                                }}
                            >
                                <Tooltip title="Open RS">
                                    <i className="fa fa-file-alt font-22" />
                                </Tooltip>
                            </IconButton>}
                            {/*
                            {previewEstimatePermitted && <IconButton onClick={() => { openEstimateModal(item); }}>
                                <Tooltip title="Preview Invoice"><span style={{ fontWeight: 'bold', fontSize: 13 }}>EST</span></Tooltip>
                            </IconButton>}
                            */}
                            <IconButton
                                style={invoiceActionButtonStyle}
                                onClick={() => {
                                    handleOpenPdfView(item);
                                }}
                            >
                                <i class="fa fa-eye font-22 " />
                            </IconButton>
                        </div>
                    ),
                };
            });
        }
        setListItems(list);
    }, [data]);

    return (
        <div className="table-adjust2">
            <GridContainer>
                <GridItem xs={12} sm={4} md={4}>
                    <CustomInputValid 
                        label="Filter by Lessee"
                        value={filtersObj.lessee}
                        onChange={(e) => {
                            const newObj = clone(filtersObj);
                            newObj.lessee = e.target.value;
                            setFiltersObj(newObj);
                        }}
                    />
                </GridItem>
                {props.isTrue && <GridItem xs={12} sm={4} md={4}>
                    <CustomInputValid 
                        label="Filter by Balance"
                        value={filtersObj.balance}
                        onChange={(e) => {
                            const newObj = clone(filtersObj);
                            newObj.balance = e.target.value;
                            setFiltersObj(newObj);
                        }}
                    />
                </GridItem>}
                <GridItem xs={12} sm={4} md={4}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={showInvoiceId}
                                onChange={e => setShowInvoiceId(e.target.checked)}
                                color="primary"
                            />
                        }
                        label="Show Invoice ID#"
                    />
                    <br />
                    <Button
                        style={{marginRight:20}}
                        color="primary"
                        onClick={() => {
                            if (filtersObj.balance || filtersObj.lessee) {
                                load(tab, filtersObj);
                            }
                        }}
                    >SUBMIT FILTER</Button>

                    <Button
                        color="white"
                        onClick={() => {
                            setFiltersObj({
                                balance: '',
                                lessee: ''
                            });
                            load(tab);
                        }}
                    >CLEAR</Button>

                </GridItem>
            </GridContainer>
            <hr />
            <ReactTable
                filterable
                className="-striped -highlight"
                showPaginationTop
                showPaginationBottom
                resizable={true}
                defaultPageSize={10}
                pageSizeOptions={[10, 20, 30]}
                data={listItems}
                columns={filteredColumns}
                getTdProps={(state, rowInfo, column) => ({
                    onClick: (e, handleOriginal) => {
                        if (tab === INVOICE_STATUS.ALL && rowInfo && rowInfo.original && column.id !== 'actions' && props.setTab) {
                            props.setTab(rowInfo.original.status);
                        }
                        if (handleOriginal) handleOriginal();
                    },
                    style: tab === INVOICE_STATUS.ALL && column.id !== 'actions' ? { cursor: 'pointer' } : {}
                })}
            />

            <Dialog open={openedDeleteModal} onClose={closeDeleteModal}>
                <DialogTitle>
                    Are you sure want to delete this invoice?
                </DialogTitle>

                <div className="text-center">
                    <Button onClick={handleClose}>Close</Button>
                    <Button
                        color="danger"
                        onClick={() => {
                            if (idToDelete) {
                                deleteInvoiceEntry(idToDelete);
                                setIsDeleting(true);
                            }
                        }}
                    >
                        Delete
                    </Button>
                </div>
            </Dialog>

            {!localPdfData && openedPdfView &&<Notification 
                open={true}
                close={() => {

                }}
                no_ok_button={true}
                message={<div><div className="fade-loader-center"><FadeLoader /></div><br />Loading PDF...</div>}
            />}

            {localPdfData && openedPdfView && (
                <InvoicePdfModal
                    pdfData={localPdfData}
                    invoice={invoiceToReview}
                    open={true}
                    close={() => {
                        setLocalPdfData(null);
                        setInvoiceToReview(null);
                        closePdfView();
                    }}
                    handleDecline={handleDecline}
                    handleApprove={handleApprove}
                    refresh={tab === INVOICE_STATUS.APPROVED ? () => {
                        console.log('rsdata?', parentData);
                        if (parentData) {
                            getInvoicePayments({
                                rs_id: parentData.rs_id
                            });
                            setWaitForInvoicePayments(true);
                            setParentData(parentData);
                        }
                    }: null}
                />
            )}

            {openPaymentHistory && (
                <InvoicePaymentHistory 
                    invoice={invoiceToReview} 
                    open={openPaymentHistory} 
                    close={handleClosePaymentHistory} 
                    tab={tab}
                />
            )}

            {openedSuccessModal &&<Notification 
                open={openedSuccessModal}
                close={() => setOpenedSuccessModal(false)}
                no_ok_button={false}
                message={success}
            />}

            {openedPRModal !== null && <InvoicePaymentHistory
                invoice={openedPRModal}
                open={true}
                close={() => {
                    setOpenedPRModal(null);
                }}
                tab={tab}
                reportMode={true}
            />}

            {openedEstimateModal !== null && <Dialog open={true} keepMounted onClose={() => {
                setOpenedEstimateModal(null);
                setEstimateRsData(null);
                setEstimatePdf(null);
            }} fullWidth={true} maxWidth="md">
                <DialogTitle>
                    <div style={{ textAlign: 'center' }}>PREVIEW INVOICE — ESTIMATED PAYMENT REPORT</div>
                </DialogTitle>
                <div style={{ padding: 20 }}>
                    {!estimateRsData && <div style={{ textAlign: 'center' }}><FadeLoader /></div>}
                    {estimateRsData && (
                        <GridContainer>
                            {(estimateRsData.invoices || []).map((inv, idx) => (
                                <GridItem xs={12} sm={12} md={12} key={`est-inv-${inv.id}`}>
                                    <div className="boxed" style={{ padding: 12, marginBottom: 12, border: '1px solid #ddd' }}>
                                        <Button color="primary" style={{ backgroundColor: '#000', color: '#fff', marginBottom: 10 }}>
                                            INVOICE #{inv.invoice_num || idx + 1}
                                        </Button>
                                        <div style={{ marginLeft: 12 }}>
                                            {(inv.payments && inv.payments.length > 0)
                                                ? inv.payments.map((p, pIdx) => (
                                                    <Button key={`est-pay-${inv.id}-${p.id}`} color="white" style={{ marginRight: 8, marginTop: 6 }}
                                                        onClick={() => previewEstimatePayment(inv, p, pIdx)}
                                                    >
                                                        PAYMENT #{pIdx + 1}
                                                    </Button>
                                                ))
                                                : (
                                                    <Button color="white" style={{ marginTop: 6 }}
                                                        onClick={() => previewEstimatePayment(inv, null, 0)}
                                                    >
                                                        PAYMENT #1 (simulated)
                                                    </Button>
                                                )
                                            }
                                        </div>
                                    </div>
                                </GridItem>
                            ))}
                            {(!estimateRsData.invoices || estimateRsData.invoices.length === 0) && (
                                <GridItem xs={12} sm={12} md={12}>
                                    <em>No invoices on this RS.</em>
                                </GridItem>
                            )}
                        </GridContainer>
                    )}
                </div>
            </Dialog>}

            {estimatePdf && <CustomPDFViewer
                pdfData={estimatePdf}
                open={true}
                close={() => { setEstimatePdf(null); }}
            />}
        </div>
    );
};

export default InvoiceList;
